import { render, staticRenderFns } from "./appointment-list-item.vue?vue&type=template&id=88bb6eb4"
import script from "./appointment-list-item.vue?vue&type=script&lang=ts"
export * from "./appointment-list-item.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports